import Resource from '@/plugins/sdk/Resource'
import { UUID, DATETIME, ARRAY, OBJECT } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dashboard'

  static get fields () {
    return {
      id: new UUID(),
      statistics: new OBJECT(),
      destination_insights: new ARRAY(),
      cost_analysis: new ARRAY(),
      top_carriers: new ARRAY(),
      top_receivers: new ARRAY(),
      lanes: new ARRAY(),
      consignment_trends: new ARRAY(),
      enquiries: new ARRAY(),
      on_for_delivery: new ARRAY(),
      recently_delivered: new ARRAY(),
      generated_at: new DATETIME()
    }
  }
}
